export default "__VITE_ASSET__59899a51__"